import styled from "styled-components";

export const MainContainer = styled.div`
	background: linear-gradient(180deg, #d7d7d7 0%, #b8b8b8 100%);
	width: 100%;
	flex-grow: 1;
`;
